
import React, { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import homeHero from './../assets/images/home_hero.png';
import Hero from './ui/Hero.js';
import { OutlineButton } from './ui/MyButton';
import image1 from '../assets/images/image1.png';
import commaImg from '../assets/images/inverted_comma.svg';
import { services, whychoose } from '../constant.js';
import image2 from '../assets/images/image2.png';
import logo from '../assets/images/libcloud_logo.svg';
import ScrollAnimation from 'react-animate-on-scroll';
import cloudImg from '../assets/images/cloud.svg';

const HomePage = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className='animated_card'>
            <style>
                {`
                    .my-button:hover {
                        background: var(--primary-gradient-100);
                        color: #FFF;
                    }

                    .infrastructure-card {
                        box-shadow: 0px 4px 5px 0px #00000033;
                        padding: 20px;
                        border-radius: 15px;
                        display: flex;
                        flex-direction: column;
                        width: 100%;
                        height: 100%;
                        box-sizing: border-box;
                        min-width: 0;
                        background: #ffffff;
                        transition: transform 0.2s ease, box-shadow 0.2s ease;
                    }

                    .infrastructure-card:hover {
                        transform: translateY(-4px);
                        box-shadow: 0px 7px 16px rgba(0, 0, 0, 0.12);
                    }

                    .infrastructure-card-image {
                        height: 100px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-shrink: 0;
                    }

                    .infrastructure-card-image img {
                        max-width: 100%;
                        max-height: 75px;
                        width: auto;
                        height: auto;
                        object-fit: contain;
                    }

                    .infrastructure-card-title {
                        font-size: 16px;
                        font-weight: 600;
                        color: var(--text-color);
                        line-height: 1.5;
                        min-height: 72px;
                        margin: 12px 0 14px;
                        overflow-wrap: break-word;
                        word-break: normal;
                    }

                    .infrastructure-card-description {
                        font-size: 15px;
                        font-weight: 400;
                        color: var(--text-color);
                        text-align: left;
                        line-height: 1.7;
                        margin: 0;
                        overflow-wrap: break-word;
                        word-break: normal;
                    }

                    @media (max-width: 575.98px) {
                        .infrastructure-card {
                            padding: 22px 18px;
                        }

                        .infrastructure-card-title {
                            min-height: auto;
                        }
                    }
                `}
            </style>

            <Hero img={homeHero}>
                <h2 style={{ color: "var(--text-color)" }}>
                    Managed library infrastructure, <br />
                    under your brand.<br />
                </h2>
            </Hero>

            {/* About Us Section */}
            <div className={`${isMobile ? "sizedbox" : ""} mt-5 row g-2 gap-5 align-items-center`}>
                <ScrollAnimation
                    animateIn='fadeInLeftBig'
                    className='col-12 col-md-5'
                    animateOut='fadeOutLeftBig'
                    duration="2"
                >
                    <div>
                        <img
                            src={image1}
                            alt='about us'
                            style={{
                                width: "100%",
                                objectFit: "cover",
                                borderRadius: isMobile ? "30px" : "0 30px 30px 0",
                                height: "auto",
                                maxHeight: "480px"
                            }}
                        />
                    </div>
                </ScrollAnimation>

                <ScrollAnimation
                    animateIn='fadeInRightBig'
                    className='col-12 col-md-5'
                    animateOut='fadeOutRightBig'
                    duration="2"
                >
                    <div>
                        <p
                            className='py-1 px-4 rounded-3'
                            style={{
                                backgroundColor: "#F4F7FE",
                                color: "var(--text-color)",
                                fontSize: "18px",
                                fontWeight: "400",
                                width: "fit-content"
                            }}
                        >
                            About Us
                        </p>

                        <h2
                            style={{
                                color: "var(--text-color)",
                                width: "75%",
                                marginTop: "10px"
                            }}
                        >
                            <img src={commaImg} alt='comma' className='me-2' />
                            Your Trusted Technology Partner
                        </h2>

                        <p
                            style={{
                                color: "var(--text-color)",
                                fontSize: "18px",
                                fontWeight: "400",
                                lineHeight: "24px",
                                marginTop: "1rem"
                            }}
                        >
                           LibCloud empowers business associates with a{" "}
    <strong>
        ready-to-deploy Koha Library Management System (LMS),
        managed cloud hosting, and dedicated mobile applications
        for Android and iOS.
    </strong>

    <br /><br />

    Our pre-hosted platform simplifies deployment and eliminates
    the need to build or manage complex server infrastructure.
    With mobile app solutions, you can extend your service
    portfolio and offer your clients convenient access to library
    services on their smartphones.

    <br /><br />

    We take care of hosting, platform maintenance, and technical
    support, enabling you to focus on client relationships,
    expand your offerings under your own brand, and grow your
    library technology business.
                        
                        </p>

                        <OutlineButton onClick={() => navigate("/about")} />
                    </div>
                </ScrollAnimation>
            </div>

            {/* Services Section */}
            <div>
                <div
                    style={{
                        padding: "25px 0",
                        backgroundImage: "linear-gradient(0, white 0 50%, #EBF1FD 50% 100%)",
                        marginTop: "50px",
                        alignItems: "center",
                        textAlign: "center"
                    }}
                >
                    <h2 style={{ color: "var(--text-color)" }}>
                        Our&nbsp;
                        <span
                            style={{
                                background: "var(--primary-gradient-100)",
                                backgroundClip: "text",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}
                        >
                            Services
                        </span>
                    </h2>

                    <ScrollAnimation
                        animateIn='fadeInUp'
                        duration="2"
                        animateOut='fadeOut'
                    >
                        <div className='sizedbox w-100 row g-3 gap-3 justify-content-center align-items-stretch'>
                            {services.map((item, index) => (
                                <div
                                    className='col-12 col-md-5 d-flex flex-column text-start'
                                    style={{
                                        boxShadow: "0px 4px 5px 0px #00000033",
                                        backgroundColor: "#FFF7FD",
                                        padding: "20px",
                                        maxWidth: "600px",
                                        borderRadius: "20px"
                                    }}
                                    key={index}
                                >
                                    <img
                                        src={item.image}
                                        alt={item.title}
                                        style={{ width: "100%" }}
                                    />

                                    <h4
                                        className='mt-4'
                                        style={{
                                            fontSize: "30px",
                                            fontWeight: "400",
                                            color: "var(--text-color)"
                                        }}
                                    >
                                        {item.title}
                                    </h4>

                                    <p
                                        className='mt-4 mb-3'
                                        style={{
                                            fontSize: "18px",
                                            fontWeight: "400",
                                            color: "var(--text-color)",
                                            textAlign: "justify"
                                        }}
                                    >
                                        {item.desc}
                                    </p>

                                    <div className='mx-auto mt-auto' style={{ width: "fit-content" }}>
                                        <OutlineButton
                                            btnbackground='#FFF7FD'
                                            onClick={() => navigate(`${item.path}`)}
                                        />
                                    </div>
                                </div>
                            ))}
                        </div>
                    </ScrollAnimation>
                </div>
            </div>

            {/* Decorative Cloud */}
            <ScrollAnimation
                animateIn='fadeInRightBig'
                duration="2"
                animateOut='fadeOutRightBig'
            >
                <div
                    className='d-flex justify-content-end w-100 z-0'
                    style={{ marginBottom: "-200px" }}
                >
                    <img src={cloudImg} alt='Cloud' />
                </div>
            </ScrollAnimation>

            {/* Why LibCloud Infrastructure Section */}
            <ScrollAnimation
                animateIn='fadeInLeftBig'
                duration="2"
                animateOut='fadeOutRightBig'
            >
                <div className='sizedbox mt-5 z-10'>
                    <h2 style={{ color: "var(--text-color)" }}>
                        Why LibCloud&nbsp;
                        <span
                            style={{
                                background: "var(--primary-gradient-100)",
                                backgroundClip: "text",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent"
                            }}
                        >
                            Infrastructure
                        </span>?
                    </h2>

                    <div className="mt-3 row g-3 align-items-stretch">
                        {whychoose.map((item, index) => (
                            <div
                                className="col-12 col-sm-6 col-lg-4 col-xxl-2 d-flex"
                                key={index}
                            >
                                <div className="infrastructure-card">
                                    {/* Image */}
                                    <div className="infrastructure-card-image">
                                        <img
                                            src={item.image}
                                            alt={item.title}
                                        />
                                    </div>

                                    {/* Title */}
                                    <h4 className="infrastructure-card-title">
                                        {item.title}
                                    </h4>

                                    {/* Description */}
                                    <p className="infrastructure-card-description">
                                        {item.desc}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </ScrollAnimation>

            {/* Bottom Hero Section */}
            <Hero className='mt-5' img={image2} background='#eff3fe'>
                <img src={logo} alt='Libcloud' />
                <h2
                    style={{
                        color: "var(--text-color)",
                        marginBottom: "20px"
                    }}
                >
                    Your Koha Implementation Specialists, Making Libraries Thrive!
                </h2>
            </Hero>
        </div>
    );
};

export default HomePage;

